export const getBodyPaddingRight = () => {
    return parseInt(getComputedStyle(document.body).paddingRight, 10) || 0;
};

export const checkBodyScrollbar = () => {
    return window.innerWidth > document.body.offsetWidth;
};
